package com.downdogapp.client.singleton

import com.downdogapp.*
import com.downdogapp.client.api.AppType.*
import kotlinx.browser.window

actual object Firebase {

  private val gtag = window.asDynamic().gtag

  private val googleAnalyticsId
    get() = when (App.appType) {
      ORIGINAL -> "UA-57988172-1"
      INTRO -> "UA-57988172-4"
      HIIT, BARRE, SEVEN, PRENATAL, MEDITATION, RUNNING, BREATHING, PILATES -> null
    }

  init {
    if (gtag != null && googleAnalyticsId != null) {
      gtag("config", googleAnalyticsId, jsObj("app_name" to "Down Dog"))
    }
  }

  actual fun logEvent(name: String, properties: Map<String, Any?>) {
    logGAEvent(name, "Event")
  }

  private fun logGAEvent(action: String, category: String, label: String? = null, value: Number? = null) {
    if (gtag != null) {
      val params = jsObj(
        "event_category" to category,
        "event_label" to label,
        "value" to value
      )
      gtag("event", action, params)
    }
  }

  actual fun onCredChanged() {}
}
